export const environment = {
  production: false,

  key: {
    size: '4096',
    http_access: '$GTrw8ifuioruowu5i4jrkjfldiuvoyfiyweho54o0tricolourfafdarerdvcx9ttrFDSda34',
    public: '-----BEGIN RSA PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA12umTzO67iC0Ny7enSR2\n7kb5bcJP9mGtWWfJICor6cjMUZmpa5ycGDf5bBWly2wav4lMgFOKlgmrgVUjGtb5\nZykNWzpRFg8Tkp/SYe4gQYI0WRKsNu7WSTk/gibxEsTbJgBg0eWIQrCZz99tk4ZB\nvebJ9GgVFta+365BRxCyQFudQK1Cz8TZ3HpCup1dmQx5MI/fogdg610JkFnTEncE\nrFQ/d7B51yi8Dt0RtZlTsUlrzBu1OtuBiKMQzIQhgM42vqhg2zzgP1PwCj5/0PmK\n5g+dj7AJz8DmEysSFIT+SVz1pWldaSdk2K/Sf3tM7iTP+Vf266NNx31gjxlCP+sa\n8QIDAQAB\n-----END RSA PUBLIC KEY-----',
    base_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.y9k01qCw1QZTuzfPi8WsGXHyUnT1uunNsBEVY3RxiRw',
  },

  url: {
    api: {
      administrator: {
        user: '/apiuser/v1/user/',
        profile: '/apiuser/v1/profile/',
        permit: '/apiuser/v1/permit/',
        feature_flags: '/apisecurity/v1/feature-flags/'
      },
      report: {
        report_type: '',
        report: '',
        speciality: '',
        author: ''
      },
      drug: {
        administration: '/apimastertables/v1/administrations/',
        adverse_effect: '/apimastertables/v1/adverseeffects/',
        commercial: '/apimastertables/v1/commertial/',
        commercial_form: '/apimastertables/v1/commertialform/',
        contraindication: '/apimastertables/v1/contraindiction/',
        drug: '/apidrug/v1/drug/',
        drug_adverse_effect: '/apidrug/v1/drugadverseeffect/',
        drug_contraindication: '/apidrug/v1/drugcontraindication/',
        drug_interaction: '/apidrug/v1/druginteraction/',
        drug_pathology: '/apidrug/v1/drugpathology/',
        drug_warning: '/apidrug/v1/drugwarning/',
        drug_subtype: '/apimastertables/v1/drugsubtype/',
        drug_type: '/apimastertables/v1/drugtype/',
        drug_generic: '/apidrug/v1/druggeneric/',
        drug_generic_administration: '/apidrug/v1/druggenericadministration/',
        drug_generic_commercial: '/apidrug/v1/druggenericcommercial/',
        drug_generic_commercial_form: '/apidrug/v1/druggenericcommercialform/',
        drug_publish: '/apidrug/v1/publish/',
        formula: '/apimastertables/v1/formula/',
        frequency_quantity: '/apimastertables/v1/frequencyquantity/',
        frequency_time: '/apimastertables/v1/frequencytime/',
        modifier: '/apimastertables/v1/modifier/',
        laboratory: '/apimastertables/v1/laboratory/',
        pathology: '/apimastertables/v1/pathology/',
        pharmaceutical_form: '/apimastertables/v1/pharmaceuticalform/',
        severity: '/apimastertables/v1/severity/',
        situation: '/apimastertables/v1/situation/',
        treatment: '/apitreatment/v1/treatment/',
        treatment_dose: '/apitreatment/v1/treatmentdose/',
        treatment_dose_value: '/apitreatment/v1/treatmentdosevalue/',
        treatment_dose_duration: '/apitreatment/v1/treatmentdoseduration/',
        treatment_dose_weight: '/apitreatment/v1/treatmentdoseweight/',
        treatment_dose_frequency: '/apitreatment/v1/treatmentdosefrequency/',
        treatment_dose_clearance: '/apitreatment/v1/treatmentdoseclearance/',
        treatment_publish: '/apitreatment/v1/publish/',
        unit_measure: '/apimastertables/v1/unitmeasure/'
      },
      congress: {
        event: '/apicongress/v1/event/',
        migrate: '/apicongress/v1/migrate/',
        congress_sponsor: '/apicongress/v1/sponsor/',
        sponsor: '/apimastertables/v1/sponsor/',
        sponsor_type: '/apimastertables/v1/sponsortype/',
      },
      vaccine: {
        crud: '/apivaccine/v1/crud/',
        conditions: '/apivaccine/v1/conditions/',
        evaluation: '/apivaccine/v1/evaluation/',
        schedule: '/apivaccine/v1/schedule/'
      },
      storage: {
        storage: '',
        storage_pdf: ''
      },
      security: {
        login: '/apisecurity/v1/login/',
        refresh_token: '/apisecurity/v1/login/newtoken',
        revoke_token: ''
      }
    }
  }
};
